import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { JsonPatchOperation } from '@core/data/models/json-patch.model';
import { ResultPage } from '@core/data/models/result-page.model';
import { mapResponseWithLocationId } from '@utils/location-header.util';
import { environment } from 'src/environments/environment';
import { TextCombination } from '../models/text-combination.model';

@Injectable({
  providedIn: 'root',
})
export class TextCombinationService {
  private readonly http = inject(HttpClient);
  protected apiUrl = `${environment.apiUrl}/text-block-combinations`;

  loadList(): Observable<TextCombination[]> {
    return this.http
      .get<ResultPage<TextCombination>>(`${this.apiUrl}`)
      .pipe(map((response) => response.result));
  }

  getById(id: string): Observable<TextCombination> {
    return this.http.get<TextCombination>(`${this.apiUrl}/${id}`);
  }

  create(category: Partial<TextCombination>): Observable<TextCombination> {
    return this.http
      .post<number>(`${this.apiUrl}`, category, {
        observe: 'response',
      })
      .pipe(
        map((response) =>
          mapResponseWithLocationId(response, category as TextCombination)
        )
      );
  }

  update(
    id: string,
    operations: JsonPatchOperation[]
  ): Observable<TextCombination> {
    return this.http.patch<TextCombination>(`${this.apiUrl}/${id}`, operations);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
